type PlaceholderPageProps = {
  title: string;
  description: string;
};

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  useDocumentMetadata(title);
  return (
    <Section spacing="large">
      <Container size="narrow">
        <div className="placeholder-page">
          <p className="eyebrow">Coming in a future milestone</p>
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      </Container>
    </Section>
  );
}
import { Container, Section } from '@/components/common';
import { useDocumentMetadata } from '@/hooks/useDocumentMetadata';
